<div class="card-header">
  <div class="headline">
    <div><ng-content select="[title]"></ng-content></div>
    <app-info-hover><ng-content select="[info]"></ng-content></app-info-hover>
  </div>
  <div class="subheadline"><ng-content select="[subtitle]"></ng-content></div>
</div>
